// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2M7bQ","header":"MergedInvoice_header__1Y7MQ"};